export default __webpack_public_path__ + "static/stab-stor-fc540fa00ccf3335af3c7cfa28285c94.svg";